// extracted by mini-css-extract-plugin
export var growableInput = "_40-0";
export var tagContainer = "_40-2";
export var textInput = "_40-1";